module.exports = __webpack_public_path__ + "img/LY.1042eba0.svg";